import { render, staticRenderFns } from "./TANav.vue?vue&type=template&id=4d322a28&scoped=true&"
import script from "./TANav.vue?vue&type=script&lang=js&"
export * from "./TANav.vue?vue&type=script&lang=js&"
import style0 from "./TANav.vue?vue&type=style&index=0&id=4d322a28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d322a28",
  null
  
)

export default component.exports